import $ from 'jquery'
import { createApp } from '@app/adapters/create-app'

import SfSidepaneContentSwitcher from '@app/shared/vue/components/layout/sf-sidepane-content-switcher.vue'
import createStore from '@app/application/communication/sections/communication/store'
import createMeetingPreparationStore from '@app/application/client_meetings/screens/prepare/stores/main'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='sidepane']").each(function () {
    const data = $(this).data()
    const endpointParams = {
      contextType: data.contextType,
      contextId: data.contextId,
      ownerType: data.ownerType,
      contextHrefParam: data.contextHrefParam,
      ledgerId: data.ledgerId,
    }

    const sidepaneApp = createApp(SfSidepaneContentSwitcher, {
      contextId: data.contextId,
      contextType: data.contextType,
      ledgerLabel: data.ledgerLabel.toString(),
      onWorkflowReview: false,
      ownerId: data.ownerId,
      ownerType: data.ownerType,
      shouldRenderAuditLog: data.shouldRenderAuditLog,
      extraData: data.extraData,
      canAddMessage: data.canAddMessage,
    })

    if (window.Silverfin.presentationMode) {
      endpointParams.companyId = Silverfin.currentCompanyId
      sidepaneApp.use(createMeetingPreparationStore(endpointParams))
    } else {
      sidepaneApp.use(createStore(endpointParams))
    }

    sidepaneApp.mount(this)
  })
})
